import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forList = ['High-performance executives who need 100% cognitive clarity every morning.', 'Founders and Entrepreneurs who handle high stress and need to protect their nervous system.', "Wearable owners who are frustrated with 'Red' scores despite trying to sleep.", 'Biohackers who want a data-driven, non-medical approach to elite recovery.'];
const notForList = ['People looking for medical cures for clinical insomnia.', "Those who don't own a tracking device (Oura, Whoop, Garmin, Apple Watch).", 'People who want a 300-page theory book instead of a 40-page action plan.'];
export function ForWhom() {
  return <section className="py-24" data-id="element-37">
      <div className="max-w-5xl mx-auto px-6" data-id="element-38">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-panel border border-brand-green/20 rounded-3xl p-8 lg:p-10" data-id="element-40">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-41">
              <span className="w-8 h-8 rounded-full bg-brand-green/20 flex items-center justify-center" data-id="element-42">
                <Check className="w-5 h-5 text-brand-green" data-id="element-43" />
              </span>
              WHO THIS IS FOR
            </h3>
            <ul className="space-y-6" data-id="element-44">
              {forList.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-45">
                  <Check className="w-5 h-5 text-brand-green shrink-0 mt-1" data-id="element-46" />
                  <span className="text-brand-gray leading-relaxed" data-id="element-47">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#050505] border border-brand-red/20 rounded-3xl p-8 lg:p-10" data-id="element-48">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-49">
              <span className="w-8 h-8 rounded-full bg-brand-red/20 flex items-center justify-center" data-id="element-50">
                <X className="w-5 h-5 text-brand-red" data-id="element-51" />
              </span>
              WHO THIS IS NOT FOR
            </h3>
            <ul className="space-y-6" data-id="element-52">
              {notForList.map((item, i) => <li key={i} className="flex gap-4 items-start" data-id="element-53">
                  <X className="w-5 h-5 text-brand-red shrink-0 mt-1" data-id="element-54" />
                  <span className="text-brand-gray leading-relaxed" data-id="element-55">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}